<template>
    <div class="app h-100" :class="{'bg-grey': $route.name === 'Mypools'}">
        <Header label="My Pools" currentpath="mypools"></Header>
        <div class="head-menu" v-if="pools && pools.length > 1 && pool">
            <div class="dropdown mx-auto" :class="{show: showMenu}">
                <a class="dropdown-toggle" @click.prevent="showMenu = !showMenu">
                    <w-icon name="myPool" v-if="pool" :type="pool.status"/>
                    <span>{{pool.name}}</span>
                    <i class="fa fa-chevron-down"></i>
                </a>
                <div class="dropdown-menu" :class="{show: showMenu}">
                    <router-link class="dropdown-item" v-for="item in pools.filter((item, index) => index !== poolIndex)" :key="item.waterBodyId"
                                 :to="{ name: $route.name, params: { id: item.waterBodyId } }">
                        <w-icon name="myPool" v-if="pool" :type="pool.status" width="23px"/>
                        {{item.name}}
                    </router-link>
                </div>
            </div>
        </div>
        <div class="d-flex h-100">
            <div class="side-menu h-100 flex-column">
                <router-link class="tab-link" v-for="(item, index) in pools" :key="item.waterBodyId" :to="{ name: $route.name, params: { id: item.waterBodyId } }">
                    <div class="pool-tab w-100" :class="{active: index === poolIndex, prev: poolIndex === index + 1}">
                        <div class="pool-tab-inner w-90 h-100 d-flex align-items-center">
                            <w-icon name="myPool" v-if="pool" :type="pool.status"/>
                            <span class="ml-3">{{item.name}}</span>
                        </div>
                    </div>
                </router-link>
                <div class="pool-tab w-100 h-100"></div>
            </div>
            <router-view v-if="pool" class="dashboard h-100 pt-4"/>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Header from '../Header'

export default {
    name: 'Mypools',
    props: ['id'],
    data () {
        return {
            showMenu: false,
            error: null
        }
    },
    components: {
        Header
    },
    computed: {
        ...mapGetters({
            pool: 'pools/pool',
            pools: 'pools/pools',
            poolIndex: 'pools/poolIndex'
        })
    },

    methods: {
        ...mapActions({
            getPools: 'pools/getPools',
            getLabResults: 'pools/getLabResults',
            setPoolId: 'pools/setPoolId'
        })
    },

    watch: {
        id () {
            this.showMenu = false
            if (this.id) {
                this.setPoolId(this.id)
            } else {
                this.$router.push({
                    name: !this.$route.name || this.$route.name === 'PoolsIndex' ? 'Mypools' : this.$route.name,
                    params: { id: this.pools[0].waterBodyId }
                }).catch(e => e)
                this.setPoolId(this.pools[0].waterBodyId)
            }
        }
    },

    created () {
        this.getPools(this.$route.query.user)
        this.getLabResults(this.$route.query.user)
        if (this.id) {
            this.setPoolId(this.id)
        } else if (this.pools && this.pools[0]) {
            this.$router.push({ name: this.$route.name || 'Mypools', params: { id: this.pools[0].waterBodyId } })
                .catch(e => e)
            this.setPoolId(this.pools[0].waterBodyId)
        }
    }
}
</script>

<style scoped>
    .app {
        padding-top: 85px;
        text-align: left;
        font-family: Nunito, sans-serif;
    }

    .side-menu {
        /*background-color: #F7F7F7;*/
        background-color: #FFF;
        display: flex;
        width: 320px;
        cursor: pointer;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .side-menu a {
        text-decoration: none;
    }

    .dashboard {
        width: calc(100% - 320px);
        background-color: #FFF;
        /*background-color: #F7F7F7;*/
        color: #1A3F65;
        overflow-y: scroll;
        overflow-x: hidden;
        padding-left: 80px;
        padding-bottom: 20px;
    }

    .pool-tab {
        height: 70px;
        font-size: 20px;
        color: #1A3F65;
        background-color: #EBEBEB;
    }

    .pool-tab.active {
        background-color: #FFF;
        /*background-color: #F7F7F7;*/
    }

    .pool-tab.active > .pool-tab-inner,
    .pool-tab.prev > .pool-tab-inner {
        border-bottom: none;
    }

    a.router-link-exact-active + a > .pool-tab,
    a.router-link-exact-active + .pool-tab {
        border-top-right-radius: 12px;
    }

    .pool-tab.prev {
        border-bottom-right-radius: 12px;
    }

    .pool-tab-inner {
        margin-left: 10%;
        border-bottom: 1px solid #CCC;
    }

    .pool-tab img {
        width: 37px;
    }

    .head-menu {
        display: none;
        width: 100%;
        height: 40px;
        background-color: #23B8DC;
        color: #fff;
        text-align: center;
    }

    .head-menu .dropdown-toggle {
        font-size: 17px;
        font-weight: 600;
    }

    .head-menu .dropdown-toggle::after {
        display: none;
    }

    .head-menu .dropdown-toggle i {
        margin-left: 10px;
    }

    .head-menu .dropdown-toggle img {
        height: 22px;
        margin-right: 13px;
    }

    .dashboard::-webkit-scrollbar,
    .side-menu::-webkit-scrollbar {
        width: 5px;
        opacity: 0;
    }

    .dashboard::-webkit-scrollbar-thumb,
    .side-menu::-webkit-scrollbar-thumb {
        -webkit-border-radius: 10px;
        border-radius: 10px;
        opacity: 0.5;
        background: #CCC;
    }

    .dropdown-item.active, .dropdown-item:active {
        color: #fff;
        text-decoration: none;
        background-color: #23B8DC;
    }

    .bg-grey .side-menu,
    .bg-grey .dashboard,
    .bg-grey .pool-tab.active {
        background-color: #F7F7F7;
    }

    @media (max-width: 768px) {
        .head-menu {
            display: flex;
        }

        .side-menu {
            display: none;
        }

        .dashboard {
            width: 100%;
            padding-left: 5%;
            overflow-x: unset;
            overflow-y: unset;
        }
    }
</style>
